<geaui-page-header pageTitle="Starter Selector" [hasBackArrow]="false" [withSidebar]="true">
  <div class="UnitsSelector">
    Units:
    <mat-radio-group [(ngModel)]="isUsUnits">
      <mat-radio-button [value]="true">US</mat-radio-button>
      <mat-radio-button [value]="false">SI</mat-radio-button>
    </mat-radio-group>
  </div>
</geaui-page-header>

<div class="Content">
  <ng-container *ngIf="isLoaded">
  <div class="filters-toolbar">
    <span class="filters-button">
      <geaui-button-v3 [type]="'primary'" class="btn-brdr-radius" preIcon="system-preferences"
        (click)="openFilters(filtersDialog)">
        Filters
      </geaui-button-v3>
    </span>
    <mat-form-field class="filter-search-field">
      <mat-label class="gea-blue">Search Starters</mat-label>
      <input type="text" matInput [(ngModel)]="viewModel.Search.Value" (ngModelChange)="searchTextChanged()" />
      <button *ngIf="viewModel.Search.Value" type="button" mat-icon-button matSuffix
        aria-label="Clear search" title="Clear search" (click)="clearFilter('Search')">
        <mat-icon class="gea-blue">close</mat-icon>
      </button>
      <mat-icon matSuffix class="gea-blue">search</mat-icon>
    </mat-form-field>
  </div>

  <div class="filter-chips" *ngIf="activeFilters.length">
    <span class="filter-chips-label">Filters Applied:</span>
    <mat-chip-set aria-label="Starter filter selections">
      <mat-chip class="geaui-chip" *ngFor="let filter of activeFilters; trackBy: trackFilter" removable
        (removed)="clearFilter(filter.key)">
        <span class="filter-chip-button">
          <button type="button" matChipRemove [attr.aria-label]="'Remove ' + filter.label">
            <mat-icon class="gea-blue">close</mat-icon>
          </button>
        </span>
        <span class="filter-chip-text">{{ filter.label }}: {{ filter.text }}</span>
      </mat-chip>
      <mat-chip class="reset-filter" removable (removed)="resetAllFilters()">
        <span class="filter-chip-text" (click)="resetAllFilters()">Reset All</span>
        <button type="button" matChipRemove aria-label="Reset all filters">
          <mat-icon class="gea-blue">replay</mat-icon>
        </button>
      </mat-chip>
    </mat-chip-set>
  </div>

  <ng-template #filtersDialog>
    <div class="filter-dialog-header">
      <h2 mat-dialog-title>Starter Filters</h2>
    </div>
    <mat-dialog-content class="starter-filter-inputs">

  <span class="VerticalBlock">
    <span class="InputBlock">
      <span class="Label">Power Consumption:</span>
      <measurement-text-box class="Value" [(Value)]="filterViewModel.PowerConsumption.Value" [Context]="MeasurementContext.Power" [IsUsUnits]="isUsUnits"></measurement-text-box>
      <span class="Unit">{{ getUnitText(MeasurementContext.Power) }}</span>
    </span>
    <br>

    <span class="InputBlock">
      <span class="Label">Motor FLA:</span>
      <component-text-box class="Value" [Value]="filterViewModel.MotorFla.Value" (ValueChange)="filterViewModel.MotorFla.Value = +$event"></component-text-box>
      <span class="Unit"></span>
    </span>
    <br>

    <span class="InputBlock">
      <span class="Label">Starter Type:</span>
      <component-drop-down class="Value" [ViewModel]="filterViewModel.StarterType"></component-drop-down>
      <span class="Unit"></span>
    </span>
    <br>

    <span class="InputBlock">
      <span class="Label">Manufacturer:</span>
      <component-drop-down class="Value" [ViewModel]="filterViewModel.Manufacturer"></component-drop-down>
      <span class="Unit"></span>
    </span>
    <br>

  </span>

  <span class="VerticalBlock">
    <span class="InputBlock">
      <span class="Label">Voltage:</span>
      <component-drop-down class="Value" [ViewModel]="filterViewModel.Voltage"></component-drop-down>
      <span class="Unit"></span>
    </span>
    <br>

    <span class="InputBlock">
      <span class="Label">Enclosure:</span>
      <component-drop-down class="Value" [ViewModel]="filterViewModel.Enclosure"></component-drop-down>
      <span class="Unit"></span>
    </span>
    <br>

    <span class="InputBlock">
      <span class="Label">Compressor Type:</span>
      <component-drop-down class="Value" [ViewModel]="filterViewModel.CompressorType"></component-drop-down>
      <span class="Unit"></span>
    </span>
    <br>

  </span>
    </mat-dialog-content>
    <div class="filter-dialog-actions">
      <button class="geaui-button-primary" type="button" (click)="applyFilterChanges()">Apply</button>
      <button class="geaui-button-secondary" type="button" (click)="cancelFilterChanges()">Cancel</button>
    </div>
  </ng-template>
  </ng-container>

  <div class="starter-table-wrapper">
    <div *ngIf="!isLoaded || loadingMessageVisible" class="selector-loading-overlay" role="status" aria-live="polite" aria-label="Loading starter selector">
      <div class="selector-loading-message">
        <span class="material-icons history-icon">update</span>
        <span>{{ loadingMessage }}</span>
      </div>
    </div>
    <table *ngIf="isLoaded">
      <thead>
        <tr>
          <th>Mfr.</th>
          <th>Power</th>
          <th>Voltage</th>
          <th>Type</th>
          <th>Enclosure</th>
          <th>Disconnect Type</th>
          <th>Trip Amps</th>
          <th>Max. Amps</th>
          <th>Interrupt Rating</th>
          <th>Wire Range (Line)</th>
          <th>H</th>
          <th>W</th>
          <th>D</th>
          <th>Weight</th>
          <th>Compressor Type</th>
          <th scope="col" aria-label="Starter details"></th>
        </tr>
        <tr class="starter-units-row">
          <td></td>
          <td>{{ getUnitText(MeasurementContext.Power) }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>(A)</td>
          <td>(A)</td>
          <td></td>
          <td>Copper Only; 75 &deg;C Min</td>
          <td>{{ getUnitText(MeasurementContext.InchOrMm) }}</td>
          <td>{{ getUnitText(MeasurementContext.InchOrMm) }}</td>
          <td>{{ getUnitText(MeasurementContext.InchOrMm) }}</td>
          <td>{{ getUnitText(MeasurementContext.Weight) }}</td>
          <td></td>
          <td></td>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let starter of viewModel.VisibleStarters.Value; let starterIndex = index">
          <tr>
            <td>{{ dropdownLabel('Manufacturer', starter.Manufacturer) }}</td>
            <td>{{ formatUnits(starter.Power, MeasurementContext.Power, 1) }}</td>
            <td>{{ starter.Voltage }}/{{ starter.Phase }}/{{ starter.Frequency }}</td>
            <td>{{ dropdownLabel('StarterType', starter.StarterType) }}</td>
            <td>{{ dropdownLabel('Enclosure', starter.Enclosure) }}</td>
            <td>{{ dropdownLabel('DisconnectType', starter.DisconnectType) }}</td>
            <td>{{ starter.TripAmps }}</td>
            <td>{{ starter.Amps }}</td>
            <td>{{ starter.InterruptRating }}</td>
            <td>{{ starter.WireRange }}</td>
            <td>{{ formatUnits(starter.Height, MeasurementContext.InchOrMm, 1) }}</td>
            <td>{{ formatUnits(starter.Width, MeasurementContext.InchOrMm, 1) }}</td>
            <td>{{ formatUnits(starter.Depth, MeasurementContext.InchOrMm, 1) }}</td>
            <td>{{ formatUnits(starter.Weight, MeasurementContext.Weight, 1) }}</td>
            <td>{{ starter.IsScrew && starter.IsPiston ? 'Screw, Piston' : starter.IsScrew ? 'Screw' : starter.IsPiston ? 'Piston' : '' }}</td>
            <td class="starter-info-cell">
              <button type="button" mat-icon-button (click)="toggleStarterDetails(starter)"
                [attr.aria-expanded]="expandedStarter === starter" [attr.aria-controls]="'starter-details-' + starterIndex"
                [attr.aria-label]="expandedStarter === starter ? 'Hide starter details' : 'Show starter details'"
                [matTooltip]="expandedStarter === starter ? 'Hide starter details' : 'Show starter details'">
                <mat-icon>info</mat-icon>
              </button>
            </td>
          </tr>
          <tr *ngIf="expandedStarter === starter" [id]="'starter-details-' + starterIndex">
            <td colspan="17" class="starter-details-cell">
              <table class="starter-details-table">
                <caption>Starter Details</caption>
                <tbody>
                  <tr *ngFor="let field of starterDetailFields">
                    <th scope="row">{{ field.label }}</th>
                    <td>{{ starterDetailValue(starter, field) }}</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </ng-container>
        <tr *ngIf="!viewModel.VisibleStarters.Value.length">
          <td colspan="17">No starters found.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>